import React, { useImperativeHandle, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from "../../utils/media-query";
import { CollapsablePanel } from "../collapsablePanel/CollapsablePanel"
import OrderForm from "../../pages/orders/orderform";
import OrderTable from "../../pages/orders/ordertable";
import './popupOrder.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  tipoOrdine: string,
  onChange: () => void,
  readonly?: boolean
}

export type OrdinePopupHandle = {
  edit: (idOrdine: number, idCliente: number) => void,
  new: () => void,
}

type state = {
  idOrdine?: number,
  idCliente: number,
  visible: boolean,
  isInsert: boolean,
  isUpdate: boolean
}

const PopupOrder: React.ForwardRefRenderFunction<OrdinePopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ idOrdine: 0, idCliente: 0, visible: false, isInsert: false, isUpdate: false });
  const { isXSmall, isSmall } = useScreenSize();
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const { t } = useTranslation();

  function hideInfo() {
    if (isChanged){
      props.onChange();
      setIsChanged(false);
    }
      
    setState({ idOrdine: 0, idCliente: 0, visible: false, isInsert: false, isUpdate: false });
  }

  useImperativeHandle(ref, () => ({
    edit(idOrdine, idCliente) {
      setState({
        idOrdine: idOrdine,
        idCliente: idCliente,
        visible: true,
        isInsert: false,
        isUpdate: true
      });
      setIsChanged(false);
    },
    new() {
      setState({
        idCliente: 0,
        visible: true,
        isInsert: true,
        isUpdate: false
      });
      setIsChanged(false);
    }
  }));

  function ordine_inserted(e: number) {
    setState({
      ...state,
      idOrdine: e
    });
    setIsChanged(true);
  }

  return (<React.Fragment>
    <Popup
      visible={state.visible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={false}
      showTitle={false}
      fullScreen={true}
      onHidden={hideInfo}
      title="Ordine"
      container=".dx-viewport"
    >
      <Position
        at="center"
        my="center"
        of=""
        collision="fit"
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        options={{
          text: t ('chiudi'),
          onClick: hideInfo,
        }}
      />

      {(() => {
        if (state.visible) {
          return (
            <React.Fragment>
              <CollapsablePanel title={t ('testataBozza')} >
                <OrderForm
                  idOrdine={state.idOrdine}
                  idCliente={state.idCliente}
                  tipoOrdine={props.tipoOrdine}
                  onUpdated={() => setIsChanged(true)}
                  onInserted={ordine_inserted}
                  readonly={props.readonly}
                  isInsert={state.isInsert}
                  isUpdate={state.isUpdate} />
              </CollapsablePanel>
              {state.idOrdine &&
                <CollapsablePanel title={t ('dettagliBozza')} >
                  <OrderTable
                    idOrdine={state.idOrdine}
                    tipoOrdine={props.tipoOrdine}
                    onChanged={() => setIsChanged(true)}
                    readonly={props.readonly} />
                </CollapsablePanel>
              }
            </React.Fragment>);
        }
      })()}
    </Popup>

  </React.Fragment>
  );
}

export default React.forwardRef(PopupOrder);